










































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { resetObjValue2NoneString } from '@/utils/tool'
import {
  getAccountList,
  addAccount,
  updateAccount,
  deleteAccount
} from '@/api/permission/permission-account/account'
import { getGroupMapList } from '@/api/permission/index'

interface IAddParams {
  uid: string
  account: string
  ladpAccount: string
  group: any[]
}
@Component({
  name: ''
})
export default class extends Vue {
  params = {
    uid: '',
    account: '',
    page: 1,
    pageCount: 20
  }
  addParams: IAddParams = {
    uid: '',
    account: '',
    ladpAccount: '',
    group: []
  }
  tableLoading = false
  tableData: any[] = []
  totalCount = 0
  groupList: Array<any> = []
  addFormVisible = false
  rules = {
    uid: [{ required: true, message: '请输入UID', trigger: 'blur' }],
    account: [{ required: true, message: '请输入账户', trigger: 'blur' }]
  }
  tableHeight: number = 500
  isEdit = false

  created() {
    this.getTableData()
    this.getGroupMapList()
  }

  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }

  async getTableData() {
    this.tableLoading = true
    let res = await getAccountList(this.params)
    this.tableData = res.data.dataList
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  async getGroupMapList() {
    let res: any = await getGroupMapList()
    let list = (Object.entries(res.data) as any[]) as string[][]
    this.groupList = list.map(item => {
      return { id: item[0], name: item[1] }
    })
  }
  async addAccount() {
    let res: any = await addAccount({
      uid: this.addParams.uid,
      account: this.addParams.account,
      ladpAccount: this.addParams.ladpAccount,
      group: this.addParams.group.join()
    })
    if (res.status.code === 0) {
      this['$message'].success('添加成功')
      setTimeout(() => {
        this.getTableData()
        this.cancelAddForm()
      }, 1500)
    } else {
      this['$message'].error('添加失败')
    }
  }
  async updateAccount() {
    let res: any = await updateAccount({
      uid: this.addParams.uid,
      account: this.addParams.account,
      ladpAccount: this.addParams.ladpAccount,
      group: this.addParams.group.join()
    })
    if (res.status.code === 0) {
      this['$message'].success('修改成功')
      setTimeout(() => {
        this.getTableData()
        this.cancelAddForm()
      }, 1500)
    } else {
      this['$message'].error('修改失败')
    }
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
  }
  handleAdd() {
    this.isEdit = false
    this.addFormVisible = true
  }
  handleEdit(item: any) {
    this.isEdit = true
    console.log(item)
    this.addParams.uid = item.uid
    this.addParams.account = item.account
    this.addParams.ladpAccount = item.ladpAccount
    this.addParams.group = (item['department'] as any[]).map(it => it.id)
    this.addFormVisible = true
  }
  handleDelete(item: any) {
    this.$confirm('是否删除该账号信息?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let uid = ''
        uid = item.uid
        let res: any = await deleteAccount({ uid })
        if (res.status.code === 0) {
          this['$message'].success('删除成功!')
          setTimeout(() => {
            this.getTableData()
          }, 1500)
        } else {
          this['$message'].error('删除失败!')
        }
      })
      .catch(() => {})
  }
  cancelAddForm() {
    (this.$refs['addParams'] as Form).resetFields()
    this.addParams.group = []
    this.addParams.ladpAccount = ''
    this.addFormVisible = false
  }
  confirmAddForm() {
    (this.$refs['addParams'] as Form).validate(valid => {
      if (valid) {
        this.isEdit ? this.updateAccount() : this.addAccount()
      } else {
        this['$message'].error('参数缺失!')
      }
    })
  }
}
